import type { SxProps, Theme } from '@mui/material/styles';

import LightboxImageTrigger from 'src/common/components/LightboxImageTrigger';
import { parseImageVisualFromClass } from 'src/helpers/tinymceImageStyles';

interface Props {
  src: string;
  alt?: string;
  className?: string;
  explicitSx?: Record<string, unknown>;
  title?: string;
}

export default function RichTextImage({
  src,
  alt,
  className = '',
  explicitSx = {},
  title,
}: Props) {
  return (
    <LightboxImageTrigger
      src={src}
      alt={alt}
      title={title}
      className={className || undefined}
      sx={[parseImageVisualFromClass(className), explicitSx] as SxProps<Theme>}
    />
  );
}
